import * as Common from '@/tenant/common';

export class TransferJournal extends Common.ObjectBase{
  constructor(){
    super('TransferJournal')
  }
  public id: number = 0;
  public bookDate: Date = new Date().getCalendarDate();
  public isPosted: boolean = false;
  public isFraction: boolean = false;
  public bookRate: number = 0;
  public currencyCode: string = '';
  public amountFC: number = 0;
  public description: string = '';
  public debitVoucherNo: string = '';
  public debitBalanceId: number = 0;
  public debitAmount: number = 0;
  public creditVoucherNo: string = '';
  public creditBalanceId: number = 0;
  public creditAmount: number = 0;

  //入金情報タブ用のダミーフィールドです。
  public state : number = 0;
  public journalType: TransferJournalTypes;  
}

  export enum TransferJournalTypes
  {
      NotSpecific = 0,
      AdvanceReceive_Book = 1,
      AdvanceReceive_Writeoff = 2,
      AccountReceivable_Writeoff = 3,
      AccountReceivable_CarryOver = 4,
      AccountReceivable_SuspenseWriteoff = 5,
      AdvancePayment_Book = 11,
      AdvancePayment_Writeoff = 12,
      AccountPayable_Writeoff = 13,
      AccountPayable_SuspenseWriteoff = 14,
  }